"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeader = exports.TabsContainer = void 0;

var _styledTools = require("styled-tools");

var _stylitas = require("@creditas/stylitas");

var _modal = require("@creditas-lab/modal");

const TabsContainer = _stylitas.styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
exports.TabsContainer = TabsContainer;
const StyledModalHeader = (0, _stylitas.styled)(_modal.ModalHeader)`
  background-color: ${(0, _styledTools.theme)('colorNeutral10')};
`;
exports.ModalHeader = StyledModalHeader;